import { DiscountDto } from "app/shared/model/DiscountDto";
import { getLocalApi } from "./localApi";
import { SaveDiscountResult } from "app/shared/model/SaveDiscountResultDto";
import apiConfig from "app/api/apiConfig.json";

export async function putDiscount(id: string, discount: DiscountDto) {
    const localApi = await getLocalApi();

    return await localApi.call(apiConfig.discounts_save_by_id.replace("{id}", encodeURIComponent(id)), 'PUT', JSON.stringify(discount))
        .then(handleSaveResult);
}

export async function postDiscount(discount: DiscountDto) {
    const localApi = await getLocalApi();

    return await localApi.call(apiConfig.discounts_save, 'POST', JSON.stringify(discount))
        .then(handleSaveResult)
}

function handleSaveResult(response: Response) : Promise<SaveDiscountResult> {

    if (!response.ok && response.status !== 400) {
        return Promise.reject(new Error('Failed to save discount'))
    }

    return response.json().then((dtoObj: any) => {
        if (response.ok && dtoObj.successful) {
            return dtoObj as SaveDiscountResult;
        }

        if (dtoObj.errors || dtoObj.Errors) {
            const errors = dtoObj.errors || dtoObj.Errors || [];
            return {
                successful: false,
                discountId: dtoObj.discountId || null,
                errors: errors.map((e: any) => ({
                    category: e.category,
                    message: e.message,
                    categorySectionHint: e.categorySectionHint
                })),
                idMap: dtoObj.idMap || {}
            } as SaveDiscountResult;
        }

        const result : Promise<SaveDiscountResult> = Promise.reject(new Error('Failed to save discount'));
        return result;
    })
}